const translations = {
  "users.UserName": "მომხმარებლის სახელი",
  "users.Email": "ელ. ფოსტა",
  "users.MustChangePassword": "პაროლი შესაცვლელია",
  "users.IsActive": "აქტიური",
  "users.AddUser": "მომხმარებლის დამატება",
  "users.EditUser": "მომხმარებლის რედაქტირება",
  "users.UserExists": "მომხმარებელი უკვე არსებობს",
  "users.Roles": "უფლებათა ჯგუფი",
};

export default translations;
